export default __webpack_public_path__ + "static/media/mac-app-background.c2434263.svg";